module.exports = __webpack_public_path__ + "media/images/flags/64/Barbados-c2fb36ac079782ecbbc269d355ecd989.png";